module.exports = __webpack_public_path__ + "static/media/bg3.f12a5180.jpg";